module.exports = __webpack_public_path__ + "img/thumb_12.71b84d67.jpg";